import { initClient } from '@ts-rest/core';
import { createBackendFetcher, readEmptyableBody, toTsRestApi } from './backend-fetcher.js';
/** 우리 백엔드(user-api / admin-api) 전용 ts-rest 클라이언트 */
export function createBackendApiClient({ contract, authClient, }) {
    return initClient(contract, {
        baseUrl: '',
        api: toTsRestApi(createBackendFetcher(authClient)),
    });
}
async function thirdPartyTsRestApi({ path, method, headers, body }) {
    // 능력 토큰·공개 API — 쿠키/AT를 보내지 않는다(CORS credentials와 충돌 방지).
    const res = await fetch(path, {
        method,
        headers,
        body,
        credentials: 'omit',
    });
    const contentType = res.headers.get('content-type');
    const parsedBody = contentType?.includes('json')
        ? await res.json()
        : await readEmptyableBody(res);
    return { status: res.status, body: parsedBody, headers: res.headers };
}
/** 제3자·공개 API — `web-auth-client`·쿠키 없음 */
export function createThirdPartyApiClient(contract, baseUrl) {
    return initClient(contract, {
        baseUrl,
        api: thirdPartyTsRestApi,
    });
}
//# sourceMappingURL=index.js.map